import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoInfo = _resolveComponent("VideoInfo")!
  const _component_FilestackS3 = _resolveComponent("FilestackS3")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_VideoInfo, {
      videoFile: _ctx.uploadedVideo.file,
      onDataExtracted: _ctx.onDataExtracted,
      onError: _ctx.handleThumbnailExtractError
    }, null, 8, ["videoFile", "onDataExtracted", "onError"]),
    _createVNode(_component_FilestackS3, {
      ref: "referenceFilestackS3",
      s3path: _ctx.s3BucketPath,
      acceptedTypes: ['video/mp4'],
      maxSize: _ctx.maxSize,
      disableStorageKey: true,
      customFilePreprocess: true,
      customFilePreprocessFun: _ctx.videoFileUploadPreProcessor,
      filestackIntent: _ctx.filestackIntent,
      onInit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('init'))),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
      onFileuploaded: _cache[2] || (_cache[2] = files => _ctx.onVideoFileUpload(files))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["s3path", "maxSize", "customFilePreprocessFun", "filestackIntent"])
  ]))
}